/**
 * @file: useAiTrialEndsAt.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { earliestTrialEnd } from './earliestTrialEnd';
import { kAiCreditFeatures } from './storeFeatureCatalog';
import { useShowsAiCreditBalance } from './useShowsAiCreditBalance';
import { useStoreFeatureLookup } from './useStoreFeature';

/**
 * While a store of the line that sees AI credits (workshop) is trying AI —
 * at least one feature that spends AI credits on a trial, sharing the trial
 * credits — the earliest of those trials' ends; else null. The AI and full
 * lines never count as trying.
 */
export function useAiTrialEndsAt(): string | null {
  const creditsLine = useShowsAiCreditBalance();
  const featureOf = useStoreFeatureLookup();
  if (!creditsLine) return null;
  return earliestTrialEnd(
    kAiCreditFeatures.map(feature => featureOf(feature).trialEndsAt),
  );
}
